import { StrictMode } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBw-BNj0WXZwyut_Ma-9P98JqKQS75EwZM",
  authDomain: "memesical.firebaseapp.com",
  projectId: "memesical",
  storageBucket: "memesical.firebasestorage.app",
  messagingSenderId: "806056129219",
  appId: "1:806056129219:web:ed5abd6915facb45b0a876",
  measurementId: "G-YKCB88R2GD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <StrictMode>
      <App />
    </StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
